(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-skin-wheel.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-skin-wheel.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  intro,
  outro,
  select,
  deSelect
} = svs.tickets.play.utils.animations.wheel;
const {
  Image
} = svs.content.image_v2;
setGlobal('svs.tickets.play.components.TicketSkinWheel', React.memo(_ref => {
  let {
    appTimeline = gsap.timeline(),
    hasFocus,
    number,
    handleGamePay,
    onHandleNumberChanged,
    chosen,
    gamePayed,
    animation = '',
    image
  } = _ref;
  const {
    useRef,
    useEffect,
    useCallback
  } = React;
  const ticketSkinRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const unmount = (intro[animation] || intro.default)(ticketSkinRef, appTimeline, number, chosen);
    return () => {
      unmount && unmount();
    };
  }, []);
  useEffect(() => {
    if (appTimeline.time() >= (appTimeline.labels.gameReady + 1 || 0) || appTimeline.progress() === 1) {
      if (chosen) {
        (select[animation] || select.default)(ticketSkinRef);
      } else {
        (deSelect[animation] || deSelect.default)(ticketSkinRef);
      }
    }
  }, [chosen]);
  useEffect(() => {
    if (gamePayed && chosen) {
      (outro[animation] || outro.default)(ticketSkinRef);
    }
  }, [gamePayed]);
  const onClick = useCallback(() => {
    if (!gamePayed && chosen) {
      handleGamePay && handleGamePay();
    } else {
      onHandleNumberChanged(number);
    }
  }, [gamePayed, chosen, handleGamePay, onHandleNumberChanged, number]);
  return React.createElement("div", {
    className: "ticket-skin-wrapper relative",
    "data-ticket-number": number,
    onClick: onClick,
    ref: ticketSkinRef,
    style: {
      transform: 'scale(0)'
    }
  }, React.createElement("div", {
    className: "ticket-number absolute"
  }, number), React.createElement("div", {
    className: "".concat(hasFocus ? 'ticket-skin-focus' : ''),
    ref: imgRef
  }, React.createElement(Image, {
    cssSelectors: "ticket-skin-shadow",
    image: _objectSpread(_objectSpread({}, image), {}, {
      altText: "Lott-".concat(number)
    })
  })));
}));

 })(window);